import React from 'react';
import {
  Alert as UiAlert,
  StatusMessageProps,
} from '@make-software/cspr-design';

export const Alert = (props: StatusMessageProps) => (
  <UiAlert scale={'xs'} lineHeight={'xs'} {...props} />
);
